var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9C0 13.95 4.05 18 9 18C13.95 18 18 13.95 18 9C18 4.05 13.95 0 9 0C4.05 0 0 4.05 0 9ZM1.125 9C1.125 4.6125 4.6125 1.125 9 1.125C13.3875 1.125 16.875 4.725 16.875 9C16.875 13.275 13.275 16.875 9 16.875C4.725 16.875 1.125 13.3875 1.125 9Z",
    fill: "#E64B38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.25C8.6625 11.25 8.4375 11.025 8.4375 10.6875V4.61255C8.4375 4.27505 8.6625 4.05005 9 4.05005C9.3375 4.05005 9.5625 4.27505 9.5625 4.61255V10.6875C9.5625 11.025 9.3375 11.25 9 11.25Z",
    fill: "#E64B38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9999 14.0624C8.7749 14.0624 8.5499 13.9499 8.4374 13.8374C8.3249 13.7249 8.2124 13.4999 8.2124 13.2749C8.2124 13.1624 8.2124 13.0499 8.2124 12.9374C8.2124 12.8249 8.3249 12.7124 8.3249 12.7124C8.5499 12.4874 8.8874 12.3749 9.1124 12.5999C9.2249 12.5999 9.3374 12.7124 9.3374 12.7124C9.4499 12.8249 9.4499 12.8249 9.4499 12.9374C9.4499 13.0499 9.4499 13.1624 9.4499 13.2749C9.4499 13.3874 9.4499 13.4999 9.4499 13.6124C9.4499 13.7249 9.3374 13.7249 9.3374 13.8374C9.4499 14.0624 9.2249 14.0624 8.9999 14.0624Z",
    fill: "#E64B38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9219082b76837cb9d7566d59bd2dcea2.svg";
export { ForwardRef as ReactComponent };